import React from 'react';
import classnames from 'classnames';
import { bool } from 'prop-types';
import { RENDERABLE } from '../../../lib/propTypes';
import classes from './index.module.scss';

const Body = ({
    children,
    hasHeader = false,
    hasFooter = false
}) => {
    const bodyClasses = classnames(classes.contentBody, 'modal-content-body', {
        [classes.roundedCorners]: !hasHeader && !hasFooter,
        [classes.roundedUpperCorners]: !hasHeader && hasFooter,
        [classes.roundedBottomCorners]: hasHeader && !hasFooter
    });

    return (
        <section className={bodyClasses}>{children}</section>
    );
};

Body.propTypes = {
    children: RENDERABLE.isRequired,
    hasHeader: bool,
    hasFooter: bool
};

export default Body;
